import { PaypalEnvs, ErrorWithMessage } from 'types';

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function copy(text: string): boolean {
  try {
    const input = document.createElement('textarea');
    document.body.appendChild(input);
    input.value = text;
    input.select();
    document.execCommand('copy');
    input.remove();
    return true;
  } catch (e) {
    return false;
  }
}

export const isInputEmpty = (value: string): boolean => value.trim() === '';

export function formatPhoneNumber(digitsStr: string): string {
  const matches = digitsStr.match(/^([0-9]{0,3})([0-9]{0,3})([0-9]{0,4})$/);
  let formattedPhoneNumber = digitsStr;
  if (matches) {
    formattedPhoneNumber = matches[1] ? `(${matches[1]}` : '';
    formattedPhoneNumber += matches[1].length === 3 ? ') ' : '';
    formattedPhoneNumber += matches[2] || '';
    formattedPhoneNumber += matches[2].length === 3 ? ' - ' : '';
    formattedPhoneNumber += matches[3] || '';
  }
  return formattedPhoneNumber;
}

export function hasOwnProp(object: unknown, prop: string): boolean {
  return Object.prototype.hasOwnProperty.call(object, prop);
}

export function hasOwnProps(object: unknown, props: string[]): boolean {
  return !props.some(prop => !hasOwnProp(object, prop));
}

export function getID(idPostfix: string): string {
  return [
    'checkout',
    idPostfix,
  ].join('-');
}

export function determinePaypalEnv(frameUrl = ''): PaypalEnvs {
  if (frameUrl.includes('honey-paypal') || frameUrl.includes('te-honey')) {
    return PaypalEnvs.Staging;
  }
  if (frameUrl.includes('sandbox')) {
    return PaypalEnvs.Sandbox;
  }
  return PaypalEnvs.Production;
}

export const isError = (error: unknown): error is ErrorWithMessage => {
  if (error && typeof error === 'object' && hasOwnProp(error, 'message')) {
    return true;
  }
  return false;
};

export const isUndef = (value: unknown): value is undefined => typeof value === 'undefined';

export const isValidOrderId = (orderId: string): boolean => {
  return Boolean(
    typeof orderId === 'string' &&
    orderId.length > 4 &&
    orderId.length < 30 &&
    !orderId.match(/.*error.*/i) &&
    !orderId.match(/.*undefined.*/i),
  );
};

export const formatPriceUSD = (value: number, forceCents = false): string => {
  const precision = forceCents ? 2 : value % 1 === 0 ? 0 : 2;
  return new Intl.NumberFormat(
    'en-US',
    {
      currency: 'USD',
      minimumFractionDigits: precision,
      style: 'currency',
    },
  ).format(value);
};
